import { useEffect, useState } from "react";
import api from "@/modules/growing-circle/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const ROLES = [
  { v: "member", l: "Member" },
  { v: "facilitator", l: "Facilitator" },
  { v: "author", l: "Author / Founder" },
  { v: "admin", l: "Administrator" },
];

export default function AdminUsers() {
  const [users, setUsers] = useState([]);

  const load = () => api.get("/admin/users").then(({ data }) => setUsers(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setRole = async (uid, role) => {
    try {
      await api.put(`/admin/users/${uid}/role`, { role });
      toast.success("Role updated.");
      load();
    } catch { toast.error("Error."); }
  };

  return (
    <div>
      <h1 className="font-heading text-3xl tracking-tight mb-2">Users & Roles</h1>
      <p className="text-muted-foreground mb-8 text-sm">Assign roles to grow the structure: facilitators, author, administrators.</p>
      <div className="space-y-3" data-testid="users-list">
        {users.map((u) => (
          <div key={u.id} className="bg-card border border-border rounded-2xl p-5 flex items-center justify-between gap-4" data-testid={`user-${u.id}`}>
            <div>
              <p className="font-medium">{u.name}</p>
              <p className="text-sm text-muted-foreground">{u.email}</p>
              <span className="text-xs text-muted-foreground">Status: {u.status}</span>
            </div>
            <Select value={u.role} onValueChange={(v) => setRole(u.id, v)}>
              <SelectTrigger className="w-52 rounded-full" data-testid={`role-select-${u.id}`}><SelectValue /></SelectTrigger>
              <SelectContent>
                {ROLES.map((r) => <SelectItem key={r.v} value={r.v}>{r.l}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </div>
  );
}
